/**
 * Component to generate and preview AI-generated physician notes.
 * Sends the reference number, OP number, template code, and a flag (`aiReport: true`)
 * to fetch the file path from the corresponding record in the `scrreporttran` table.
 * Generates and displays the AI-generated report preview.
 *
 */

import { useState } from 'react';
import { message, Space, Modal, Form } from 'antd';
import { AimOutlined, FileOutlined } from '@ant-design/icons';
import { Button } from 'soxo-bootstrap-core';
import { Opreg, MedicalReports } from '../../../models';
import './generate-ai-notes.scss';

import EditorWrapper from '../../../components/editor-wrapper/editor-wrapper';

// Reusable AiNotes Component
export default function AiNotes({ templateDetails, referenceId, opNo, templateCode, generateAiReportModal,setHtml }) {
    const [templateLoading, setTemplateLoading] = useState(false);
    const [reportModelVisible, setReportModalVisible] = useState(false);

    const [htmlContent, setHtmlContent] = useState();
    const [form] = Form.useForm();

    // Function to handle the generate button click event
    async function handleGenerateReport({ templateDetails, referenceId, opNo, setTemplateLoading, templateCode }) {
        // Set the loading state to true to indicate that the template is being generated
        setTemplateLoading(true);

        // Check if the templateDetails object is present and has a valid tmpl_code
        if (templateDetails?.tmpl_code || templateCode) {
            // Create the form body to pass to the API for generating the report
            let formbody = {
                template_code: templateDetails?.tmpl_code ? templateDetails.tmpl_code : templateCode, // Template code to identify which template to use
                referenceId: referenceId, // Reference ID associated with the report
                aiReport: true, // Flag to indicate that an AI report should be generated
            };

            // Call the API to get the report
            const result = await Opreg.getReport(formbody, opNo);

            if (result.success) {
                // Set the generated HTML content in the editor
                if(generateAiReportModal){
                    setReportModalVisible(true);
                    setHtmlContent(result.html);
                    setTemplateLoading(false);
                }
                setHtml(result.html);
                setTemplateLoading(false);
            } else {
                // Show an error message with the result message
                message.error(result.message);
                setTemplateLoading(false);//loading false
                // Ensure that the HTML content is not rendered or cleared
                setHtml(null);
            }

            // Set the loading state to false to indicate that the template generation is complete
            setTemplateLoading(false);
        } else {
            // Display an error message if the template is not valid or not selected
            message.error('Please select a valid template');
            setTemplateLoading(false);
        }
    }

    /**
     * Function to save  reports
     * @param {*} param0
     * @returns
     */
    const saveReport = async ({ edit }) => {
        const values = form.getFieldsValue();
        const body = {
            ...values,
            // id: currentReportId,
            opno: opNo,
            report: htmlContent,
            doctorptr: values.doctor,
        };
        MedicalReports.saveMedicalreport(body).then((result) => {
            if (result.success) {
                message.success(result.message);

                // setCurrentReportId(result.id);
            } else {
                message.error(result.message);
            }
        });
    };

    /**
     * The `handleCloseGenerateReportModal` function sets the visibility of the report send modal to false.
     */
    const handleCloseReportModal = () => {
        setReportModalVisible(false);
    };

   

    return (
        <div className="ai-notes">
            {/* {generateAiReportModal ? null : <div>Generate AI Notes</div>} */}
            <div>
                {(templateDetails?.tmpl_code || templateCode == 'AIRPT') && !generateAiReportModal && (
                    <Button
                        className="submit-button"
                        type="primary"
                        size={'small'}
                        htmlType="submit"
                        loading={templateLoading}
                        onClick={() => {
                                handleGenerateReport({
                                templateDetails,
                                referenceId,
                                opNo,
                                setHtml,
                                setTemplateLoading,
                                templateCode,
                            });
                        }}
                    >
                        <AimOutlined />
                       View AI Physician Note
                    </Button>
                )}
                {/*  generate Report modal starts  */}
                {generateAiReportModal ? (
                    <Modal
                        destroyOnClose={true}
                        footer={null}
                        className="payment"
                        visible={reportModelVisible}
                        //  onOk={() => {
                        //     setVisible(true);
                        //      }}

                        onCancel={handleCloseReportModal}
                        width={'50%'}
                        style={{ height: '80%',top:'0px' }} // Adjust the height (80% of viewport height in this case)
                        bodyStyle={{ overflowY: 'auto' }} // Add scrolling for content if neededd scroll if content exceeds height
                        // maskClosable={false}
                    >
                        <div>
                            <div>
                                <h3>REPORT DETAILS</h3>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
                                {/* Title Section */}

                                {/* Buttons */}
                                <Space>
                                    {/* <Checkbox> {t('SAVE & PRINT')}</Checkbox> */}
                                    <Button size={'small'} type="primary" icon={<FileOutlined />} onClick={saveReport}>
                                        SAVE
                                    </Button>
                                    <Button size={'small'} onClick={handleCloseReportModal}>
                                        Cancel
                                    </Button>
                                </Space>
                            </div>
                            <div>
                                {/* Display the generated HTML in an Editor */}
                                
                                <EditorWrapper
                                value={htmlContent}
                                height= {500}
                                menubar={false} // Disable the menubar
                                toolbar= {false} // Disable the toolbar
                                plugins={ []} // Disable all plugins/>

                               />

                                {/*  generate report tab ends  */}
                                {/* </Tabs> */}
                            </div>
                        </div>
                    </Modal>
                ) : null}
                {/* generate Report Model end */}
            </div>
        </div>
    );
}
